<template>
  <b-modal
    ref="modal"
    size="xl"
    title="Create Inventory Category"
    title-class="font-18"
    :no-close-on-backdrop="true"
    hide-footer
    @hidden="$emit('hidden')"
    scrollable
  >
    <validationObserver ref="createView">
      <b-form @submit.prevent="onSubmit" @reset.prevent="onConfirmReset">
        <b-form-group
          label="Root"
          label-for="input_root"
          label-cols-sm="3"
          v-if="level !== 1"
        >
          <label class="col-form-label col-sm-7">{{ root }}</label>
        </b-form-group>
        <b-form-group
          label="ประเภท"
          label-for="type"
          label-cols-sm="3"
          v-if="level !== 1"
        >
          <label class="col-form-label col-sm-7">{{ type }}</label>
        </b-form-group>
        <validationProvider
          v-if="level === 1"
          v-slot="{ errors }"
          name="OFM Code"
          :rules="{
            dynamicRequired: ['กรุณาระบุรหัสหมวดหมู่ 1 ตัวอักษร'],
            duplicateName: [isValidate.code, 'รหัสซ้ำกับข้อมูลที่อยู่ในระบบ'],
          }"
        >
          <b-form-group
            label="รหัส (OFM)"
            label-for="input_code"
            label-cols-sm="3"
          >
            <b-form-input
              id="input_code"
              type="text"
              v-model="input.code"
              placeholder="ระบุรหัสหมวดหมู่"
              maxlength="1"
              :class="{
                'is-invalid': errors && errors.length,
                'is-valid': !(errors && errors.length) && input.code,
              }"
              @keyup="onValidateInventoryCode($event)"
            ></b-form-input>
            <div v-if="errors && errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>
        <validationProvider
          v-if="level === 2"
          v-slot="{ errors }"
          name="OFM Code"
          :rules="{
            dynamicRequired: ['กรุณาระบุรหัสหมวดหมู่ 2 ตัวอักษร'],
            duplicateName: [isValidate.code, 'รหัสซ้ำกับข้อมูลที่อยู่ในระบบ'],
          }"
        >
          <b-form-group
            label="รหัส (OFM)"
            label-for="input_code"
            label-cols-sm="3"
          >
            <b-form-input
              id="input_code"
              type="text"
              v-model="input.code"
              placeholder="ระบุรหัสหมวดหมู่"
              maxlength="2"
              :class="{
                'is-invalid': errors && errors.length,
                'is-valid': !(errors && errors.length) && input.code,
              }"
              @keyup="onValidateInventoryCode($event)"
            ></b-form-input>
            <div v-if="errors && errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>
        <validationProvider
          v-slot="{ errors }"
          name="Thai Name"
          :rules="{
            dynamicRequired: ['กรุณาระบุชื่อหมวดหมู่เป็นภาษาไทย'],
            duplicateName: [
              isValidate.display_name_th,
              'ชื่อหมวดหมู่ภาษาไทยซ้ำกับข้อมูลที่อยู่ในระบบ',
            ],
            validateWithSpecialCharacters: true,
          }"
        >
          <div class="form-row form-group">
            <label class="col-sm-3 col-form-label">ชื่อ (ไทย)</label>
            <div class="col-sm-9">
              <div role="group" class="input-group check-length">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    TH
                  </div>
                </div>
                <input
                  id="input_displayname_th"
                  name="input_displayname_th"
                  type="text"
                  class="form-control"
                  placeholder="ระบุชื่อหมวดหมู่ภาษาไทย"
                  v-model="input.display_name.th"
                  maxlength="50"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) && input.display_name.th,
                  }"
                  v-on:keyup="onValidateDisplaynameTH($event)"
                />
                <span class="input-validate-length">
                  {{ input.display_name.th.length }}/50
                </span>
              </div>
              <div v-if="errors && errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </div>
          </div>
        </validationProvider>
        <validationProvider
          v-slot="{ errors }"
          name="English Name"
          :rules="{
            dynamicRequired: ['กรุณาระบุชื่อหมวดหมู่เป็นภาษาอังกฤษ'],
            duplicateName: [
              isValidate.display_name_en,
              'ชื่อหมวดหมู่ภาษาอังกฤษซ้ำกับข้อมูลที่อยู่ในระบบ',
            ],
            validateEngWithSpecialCharacters: true,
          }"
        >
          <div class="form-row form-group">
            <label class="col-sm-3 col-form-label">ชื่อ (อังกฤษ)</label>
            <div class="col-sm-9">
              <div role="group" class="input-group check-length">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    EN
                  </div>
                </div>
                <input
                  id="input_displayname_en"
                  name="input_displayname_en"
                  type="text"
                  class="form-control"
                  placeholder="ระบุชื่อหมวดหมู่ภาษาอังกฤษ"
                  v-model="input.display_name.en"
                  maxlength="50"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) && input.display_name.en,
                  }"
                  v-on:keyup="onValidateDisplaynameEN($event)"
                />
                <span class="input-validate-length">
                  {{ input.display_name.en.length }}/50
                </span>
              </div>
              <div v-if="errors && errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </div>
          </div>
        </validationProvider>
        <b-form-group
          label="ประเภท"
          label-for="input_type"
          label-cols-sm="3"
          v-if="level === 1"
        >
          <div class="row col-sm-9 col-form-label">
            <b-form-radio
              v-model="input.type"
              name="input_type"
              class="custom-control custom-radio custom-radio-info mb-3"
              value="OFMStock"
              style="margin-right:10px;"
              >OFMStock</b-form-radio
            >
            <b-form-radio
              v-model="input.type"
              name="input_type"
              class="custom-control custom-radio custom-radio-info mb-3"
              value="DropShip"
              >DropShip</b-form-radio
            >
          </div>
        </b-form-group>
        <validationProvider
          v-if="level === 2"
          v-slot="{ errors }"
          name="Product Line"
          :rules="{
            dynamicRequired: ['กรุณาระบุ Product Line'],
          }"
        >
          <b-form-group
            label="Product Line"
            label-for="input_product_line"
            label-cols-sm="3"
          >
            <b-form-input
              id="input_product_line"
              type="text"
              v-model="input.product_line"
              placeholder="ระบุ Product Line"
              maxlength="2"
              :class="{
                'is-invalid': errors && errors.length,
                'is-valid': !(errors && errors.length) && input.product_line,
              }"
            ></b-form-input>
            <div v-if="errors && errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>
        <validationProvider
          v-if="level === 2"
          v-slot="{ errors }"
          name="GP Standard"
          :rules="{
            validateNum2Decimal: true,
            dynamicRequired: ['กรุณาระบุ GP Standard'],
          }"
        >
          <b-form-group
            label="GP Standard (%)"
            label-for="input_gp_standard"
            label-cols-sm="3"
          >
            <b-form-input
              id="input_gp_standard"
              type="number"
              step=".01"
              v-model="input.gp_standard"
              placeholder="ระบุ GP Standard"
              :class="{
                'is-invalid': errors && errors.length,
                'is-valid': !(errors && errors.length) && input.product_line,
              }"
            ></b-form-input>
            <div v-if="errors && errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>
        <b-form-group
          label="สำหรับสินค้าฟรี"
          label-for="input_is_free"
          label-cols-sm="3"
        >
          <div class="row col-sm-9 col-form-label" v-if="is_free === false">
            <b-form-radio
              v-model="input.is_free"
              name="input_is_free"
              class="custom-control custom-radio custom-radio-info mb-3"
              :value="true"
              style="margin-right:10px;"
              >Yes</b-form-radio
            >
            <b-form-radio
              v-model="input.is_free"
              name="input_is_free"
              class="custom-control custom-radio custom-radio-info mb-3"
              :value="false"
              >No</b-form-radio
            >
          </div>
          <div class="row col-sm-9 col-form-label" v-else>
            <b-form-radio
              v-model="input.is_free"
              name="input_is_free"
              class="custom-control custom-radio custom-radio-info mb-3"
              :value="true"
              style="margin-right:10px;"
              disabled
              >Yes</b-form-radio
            >
            <b-form-radio
              v-model="input.is_free"
              name="input_is_free"
              class="custom-control custom-radio custom-radio-info mb-3"
              :value="false"
              disabled
              >No</b-form-radio
            >
          </div>
        </b-form-group>
        <validationProvider
          v-slot="{ errors }"
          name="Status"
          :rules="{ dynamicRequired: ['กรุณาเลือกสถานะ'] }"
        >
          <b-form-group
            label="สถานะ"
            label-for="input_status"
            label-cols-sm="3"
          >
            <div class="row col-sm-9 col-form-label">
              <b-form-radio
                v-model="input.status"
                name="input_status"
                class="custom-control custom-radio custom-radio-info mb-3"
                value="Active"
                style="margin-right:10px;"
                >Active</b-form-radio
              >
              <b-form-radio
                v-model="input.status"
                name="input_status"
                class="custom-control custom-radio custom-radio-info mb-3"
                value="Inactive"
                >Inactive</b-form-radio
              >
            </div>
            <div v-if="errors && errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>
        <b-form-group
          label="สำหรับจัดการสินค้า"
          label-for="input_is_control_product"
          label-cols-sm="3"
        >
          <div class="row col-sm-9 col-form-label">
            <b-form-radio-group
              :disabled="level !== lockLevel"
              v-model="input.is_control_product"
              name="input_is_control_product"
            >
              <b-form-radio
                class="custom-control custom-radio custom-radio-info mb-3"
                :value="true"
                style="margin-right:10px;"
                >Yes</b-form-radio
              >
              <b-form-radio
                class="custom-control custom-radio custom-radio-info mb-3"
                :value="false"
                >No</b-form-radio
              >
            </b-form-radio-group>
          </div>
        </b-form-group>
        <div
          class="form-group row mb-4"
          v-if="input.is_control_product === true"
        >
          <label class="col-form-label col-sm-3">Hybrid Category</label>
          <div class="col-sm-9">
            <div class="row">
              <div class="col-sm-10">
                <MappingHybridCategorySelector
                  :level="5"
                  :displayKey="`view_name`"
                  :idKey="`view_id`"
                  :childrenItemsKey="`items`"
                  :items="hybridCategoryItems"
                  :reload="isClearCategorySelector"
                  :isSelectLastChild="true"
                  @result="onHybridCategorySelector"
                ></MappingHybridCategorySelector>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="btn btn-success waves-effect waves-light"
                  @click="onAddMappingHybridCategory"
                >
                  Add
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="table-responsive">
                  <b-table
                    class="table table-centered table-nowrap"
                    ref="mappingHybridCategorytable"
                    :empty-text="'ไม่พบข้อมูล'"
                    :show-empty="mappingHybridCategoryItems.length == 0"
                    :bordered="true"
                    :items="mappingHybridCategoryItems"
                    align="center"
                    v-bind:fields="fields"
                    :perPage="perPage"
                  >
                    <template v-slot:cell(index)="data">
                      <div class="text-right">
                        {{ (firstRowOnPage + data.index) | number }}
                      </div>
                    </template>
                    <template v-slot:cell(action)="data">
                      <div class="button-items">
                        <button
                          type="button"
                          class="btn btn-danger waves-effect waves-light"
                          title="Delete"
                          @click="onDeleteMappingHybridCategory(data.item.id)"
                        >
                          <i class="mdi mdi-trash-can label-icon"></i>
                        </button>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="modal-footer">
          <div class="button-items" style="float: right;">
            <button type="submit" class="btn btn-primary">
              <i class="bx bx-save" />Save
            </button>
            <button type="reset" class="btn btn-light">
              <i class="bx bx-reset" />Reset
            </button>
          </div>
        </div>
      </b-form>
    </validationObserver>
  </b-modal>
</template>
<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import hybridCategoryService from '@/helpers/service/hybrid-category-service'
import inventoryCategoryService from '@/helpers/service/inventory-category-service'
import { StatusEnum } from '@/enum/status.enum.js'
import {
  InventoryTypeEnum,
  InventoryLockLevel,
} from '@/enum/inventory-category.enum.js'
import { eventBus } from '@/main.js'
import MappingHybridCategorySelector from '@/components/mappinghybridcategory/mapping-hybrid-category-selector'
export default {
  components: { MappingHybridCategorySelector },
  props: {
    activeModal: {
      type: Boolean,
      default: false,
    },
    parent_id: {
      type: String,
      default: null,
    },
    level: {
      type: Number,
      default: 0,
    },
    root: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    is_free: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mappingHybridCategoryValue: null,
      mappingHybridCategoryItems: [],
      hybridCategoryItems: [],
      openModal: false,
      input: {
        id: null,
        parent_id: null,
        level: 0,
        code: null,
        display_name: {
          th: '',
          en: '',
        },
        product_line: null,
        gp_standard: null,
        type: null,
        status: StatusEnum.ACTIVE,
        is_free: false,
        is_control_product: false,
        mapping_hybrid_categories: [],
        isSelectHybridCategory: false,
        create_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
        update_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
      },
      isValidate: {
        code: false,
        display_name_th: false,
        display_name_en: false,
      },
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'code_level_1',
          label: 'รหัส Level 1',
          sortable: true,
        },
        {
          key: 'display_name_level_1.th',
          label: 'ชื่อ Level 1 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_1.en',
          label: 'ชื่อ Level 1 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_2',
          label: 'รหัส Level 2',
          sortable: true,
        },
        {
          key: 'display_name_level_2.th',
          label: 'ชื่อ Level 2 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_2.en',
          label: 'ชื่อ Level 2 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_3',
          label: 'รหัส Level 3',
          sortable: true,
        },
        {
          key: 'display_name_level_3.th',
          label: 'ชื่อ Level 3 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_3.en',
          label: 'ชื่อ Level 3 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_4',
          label: 'รหัส Level 4',
          sortable: true,
        },
        {
          key: 'display_name_level_4.th',
          label: 'ชื่อ Level 4 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_4.en',
          label: 'ชื่อ Level 4 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_5',
          label: 'รหัส Level 5',
          sortable: true,
        },
        {
          key: 'display_name_level_5.th',
          label: 'ชื่อ Level 5 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_5.en',
          label: 'ชื่อ Level 5 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      perPage: 100,
      firstRowOnPage: 1,
      isClearCategorySelector: false,
      lockLevel: InventoryLockLevel,
    }
  },
  watch: {
    activeModal: function(value) {
      if (value) {
        this.$refs.modal.show()
        this.mappingHybridCategoryValue = null
        this.mappingHybridCategoryItems = []
        this.input = {
          id: null,
          parent_id: null,
          level: 0,
          code: null,
          display_name: {
            th: '',
            en: '',
          },
          product_line: null,
          gp_standard: null,
          type: null,
          status: StatusEnum.ACTIVE,
          is_free: false,
          is_control_product: false,
          mapping_hybrid_categories: [],
          create_info: {
            timestamp: '',
            user_id: '',
            user_name: '',
          },
          update_info: {
            timestamp: '',
            user_id: '',
            user_name: '',
          },
        }
        if (this.level === 1) {
          this.input.type = InventoryTypeEnum.OFMStock
        } else {
          this.input.is_free = this.is_free
        }
        this.isValidate = {
          code: false,
          display_name_th: false,
          display_name_en: false,
        }
      } else {
        this.$refs.modal.hide()
      }
    },
  },
  async mounted() {
    await this.getHybridCategory()
  },
  methods: {
    onSubmit() {
      console.log('onSubmit')
      this.$refs.createView.validate().then(result => {
        console.log('onSubmit validate', result)
        if (this.input.isSelectHybridCategory) {
          this.$utils.notificationAck(
            'warning',
            'กรุณาเพิ่มหรือลบ Hybrid Category ก่อน'
          )
          return
        }

        if (result) {
          this.input.display_name.th = this.input.display_name.th.trim()
          this.input.display_name.en = this.input.display_name.en.trim()
          if (this.level !== 1) {
            this.input.type = this.type
          }
          this.mappingHybridCategoryItems.forEach(element => {
            let tempParentItems = []
            if (element.level === 1) {
              let mapping_hybrid_categories = {
                hybrid_category_id: element.id,
                hybrid_parent_id: null,
                hybrid_code: element.code_level_1,
                hybrid_level: 1,
                hybrid_category_display_name: {
                  th: element.display_name.th,
                  en: element.display_name.en,
                },
                hybrid_parent_categories: tempParentItems,
              }
              this.input.mapping_hybrid_categories.push(
                mapping_hybrid_categories
              )
            } else if (element.level === 2) {
              let tempParentLevel1 = {
                pim_id: element.id_level_1,
                parent_id: null,
                code: element.code_level_1,
                level: 1,
                display_name: {
                  th: element.display_name_level_1.th,
                  en: element.display_name_level_1.en,
                },
              }
              tempParentItems.push(tempParentLevel1)
              let mapping_hybrid_categories = {
                hybrid_category_id: element.id,
                hybrid_parent_id: element.id_level_1,
                hybrid_code: element.code_level_2,
                hybrid_level: 2,
                hybrid_category_display_name: {
                  th: element.display_name.th,
                  en: element.display_name.en,
                },
                hybrid_parent_categories: tempParentItems,
              }
              this.input.mapping_hybrid_categories.push(
                mapping_hybrid_categories
              )
            } else if (element.level === 3) {
              let tempParentLevel1 = {
                pim_id: element.id_level_1,
                parent_id: null,
                code: element.code_level_1,
                level: 1,
                display_name: {
                  th: element.display_name_level_1.th,
                  en: element.display_name_level_1.en,
                },
              }
              tempParentItems.push(tempParentLevel1)
              let tempParentLevel2 = {
                pim_id: element.id_level_2,
                parent_id: element.id_level_1,
                code: element.code_level_2,
                level: 2,
                display_name: {
                  th: element.display_name_level_2.th,
                  en: element.display_name_level_2.en,
                },
              }
              tempParentItems.push(tempParentLevel2)
              let mapping_hybrid_categories = {
                hybrid_category_id: element.id,
                hybrid_parent_id: element.id_level_2,
                hybrid_code: element.code_level_3,
                hybrid_level: 3,
                hybrid_category_display_name: {
                  th: element.display_name.th,
                  en: element.display_name.en,
                },
                hybrid_parent_categories: tempParentItems,
              }
              this.input.mapping_hybrid_categories.push(
                mapping_hybrid_categories
              )
            } else if (element.level === 4) {
              let tempParentLevel1 = {
                pim_id: element.id_level_1,
                parent_id: null,
                code: element.code_level_1,
                level: 1,
                display_name: {
                  th: element.display_name_level_1.th,
                  en: element.display_name_level_1.en,
                },
              }
              tempParentItems.push(tempParentLevel1)
              let tempParentLevel2 = {
                pim_id: element.id_level_2,
                parent_id: element.id_level_1,
                code: element.code_level_2,
                level: 2,
                display_name: {
                  th: element.display_name_level_2.th,
                  en: element.display_name_level_2.en,
                },
              }
              tempParentItems.push(tempParentLevel2)
              let tempParentLevel3 = {
                pim_id: element.id_level_3,
                parent_id: element.id_level_2,
                code: element.code_level_3,
                level: 3,
                display_name: {
                  th: element.display_name_level_3.th,
                  en: element.display_name_level_3.en,
                },
              }
              tempParentItems.push(tempParentLevel3)
              let mapping_hybrid_categories = {
                hybrid_category_id: element.id,
                hybrid_parent_id: element.id_level_3,
                hybrid_code: element.code_level_4,
                hybrid_level: 4,
                hybrid_category_display_name: {
                  th: element.display_name.th,
                  en: element.display_name.en,
                },
                hybrid_parent_categories: tempParentItems,
              }
              this.input.mapping_hybrid_categories.push(
                mapping_hybrid_categories
              )
            } else if (element.level === 5) {
              let tempParentLevel1 = {
                pim_id: element.id_level_1,
                parent_id: null,
                code: element.code_level_1,
                level: 1,
                display_name: {
                  th: element.display_name_level_1.th,
                  en: element.display_name_level_1.en,
                },
              }
              tempParentItems.push(tempParentLevel1)
              let tempParentLevel2 = {
                pim_id: element.id_level_2,
                parent_id: element.id_level_1,
                code: element.code_level_2,
                level: 2,
                display_name: {
                  th: element.display_name_level_2.th,
                  en: element.display_name_level_2.en,
                },
              }
              tempParentItems.push(tempParentLevel2)
              let tempParentLevel3 = {
                pim_id: element.id_level_3,
                parent_id: element.id_level_2,
                code: element.code_level_3,
                level: 3,
                display_name: {
                  th: element.display_name_level_3.th,
                  en: element.display_name_level_3.en,
                },
              }
              tempParentItems.push(tempParentLevel3)
              let tempParentLevel4 = {
                pim_id: element.id_level_4,
                parent_id: element.id_level_3,
                code: element.code_level_4,
                level: 4,
                display_name: {
                  th: element.display_name_level_4.th,
                  en: element.display_name_level_4.en,
                },
              }
              tempParentItems.push(tempParentLevel4)
              let mapping_hybrid_categories = {
                hybrid_category_id: element.id,
                hybrid_parent_id: element.id_level_4,
                hybrid_code: element.code_level_5,
                hybrid_level: 5,
                hybrid_category_display_name: {
                  th: element.display_name.th,
                  en: element.display_name.en,
                },
                hybrid_parent_categories: tempParentItems,
              }
              this.input.mapping_hybrid_categories.push(
                mapping_hybrid_categories
              )
            }
          })
          this.$emit('createView', this.input)
        }
      })
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            this.mappingHybridCategoryValue = null
            this.mappingHybridCategoryItems = []
            this.input = {
              id: null,
              parent_id: null,
              level: 0,
              code: null,
              display_name: {
                th: '',
                en: '',
              },
              product_line: null,
              gp_standard: null,
              type: this.type,
              status: StatusEnum.ACTIVE,
              is_free: false,
              is_control_product: false,
              mapping_hybrid_categories: [],
              create_info: {
                timestamp: '',
                user_id: '',
                user_name: '',
              },
              update_info: {
                timestamp: '',
                user_id: '',
                user_name: '',
              },
            }
            if (this.level === 1) {
              this.input.type = InventoryTypeEnum.OFMStock
            } else {
              this.input.is_free = this.is_free
            }
            this.isClearCategorySelector = !this.isClearCategorySelector
            this.isValidate = {
              code: false,
              display_name_th: false,
              display_name_en: false,
            }
          }
        })
    },
    async onValidateDisplaynameTH() {
      if (
        !(
          this.input.display_name.th.trim() === '' ||
          this.input.display_name.th.trim() === null ||
          this.input.display_name.th.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('nameTH', this.input.display_name.th.trim())
        if (this.input.parent_id !== null) {
          params.append('parent_id', this.input.parent_id)
        }
        let result = await inventoryCategoryService.headInventoryCategoryAsync(
          params
        )
        if (result.status === 200) {
          this.isValidate.display_name_th = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_th = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onValidateDisplaynameEN() {
      if (
        !(
          this.input.display_name.en.trim() === '' ||
          this.input.display_name.en.trim() === null ||
          this.input.display_name.en.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('nameEN', this.input.display_name.en.trim())
        if (this.parent_id !== null) {
          params.append('parent_id', this.parent_id)
        }
        let result = await inventoryCategoryService.headInventoryCategoryAsync(
          params
        )
        if (result.status === 200) {
          this.isValidate.display_name_en = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_en = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onValidateInventoryCode() {
      if (
        !(
          this.input.code.trim() === '' ||
          this.input.code.trim() === null ||
          this.input.code.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('code', this.input.code.trim())
        if (this.parent_id !== null) {
          params.append('parent_id', this.parent_id)
        }
        let result = await inventoryCategoryService.headInventoryCategoryAsync(
          params
        )
        if (result.status === 200) {
          this.isValidate.code = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.code = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async getHybridCategory() {
      let params = new URLSearchParams()
      params.append('status', StatusEnum.ACTIVE)
      params.append('isControlProduct', true)
      let result = await hybridCategoryService.getMappingHybridCategoryTreeNodeAsync(
        params
      )
      if (result.status === 200) {
        if (result.data.length) {
          this.hybridCategoryItems = result.data
        }
      }
    },
    onHybridCategorySelector(obj) {
      this.mappingHybridCategoryValue = obj.id
      this.input.isSelectHybridCategory = obj.isSuccess
    },
    async onAddMappingHybridCategory() {
      if (
        this.mappingHybridCategoryValue !== null &&
        this.mappingHybridCategoryItems.findIndex(
          element => element.id === this.mappingHybridCategoryValue
        ) === -1
      ) {
        let params = new URLSearchParams()
        params.append('pageSize', this.perPage)
        params.append('id', this.mappingHybridCategoryValue)
        let result = await hybridCategoryService.getHybridCategoryListAsync(
          params
        )
        if (result.status === 200) {
          this.mappingHybridCategoryItems.push(result.data.items[0])
          this.isClearCategorySelector = !this.isClearCategorySelector
          console.log(this.mappingHybridCategoryItems)
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          console.log('error', result.response.data.message)
        } else {
          this.$utils.notification('error', result.response.data.message, 2000)
        }
      } else {
        this.$utils.notification('error', 'มีการ Add ข้อมูลนี้ไปแล้ว', 2000)
      }
    },
    onDeleteMappingHybridCategory(id) {
      this.mappingHybridCategoryItems.splice(
        this.mappingHybridCategoryItems.findIndex(element => element.id === id),
        1
      )
    },
  },
}
</script>
